import {chakra} from '@chakra-ui/system';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import type {ComponentType, FC} from 'react';
import {createElement} from 'react';

import {useStyles} from './context';
import {parts} from './theme/anatomy';

type Props = {
  icon: IconDefinition | ComponentType;
};

export const NavIcon: FC<Props> = ({icon}: Props) => {
  const {icon: style} = useStyles();
  if (!icon) return null;
  if (isIconDefinition(icon)) return <ChakraFontAwesomeIcon {...parts.icon.attrs} sx={style} icon={icon as any} />;
  return createElement(icon, {});
};

const isIconDefinition = (icon: IconDefinition | ComponentType): icon is IconDefinition => {
  return (icon as IconDefinition).iconName !== undefined;
};

const ChakraFontAwesomeIcon = chakra(FontAwesomeIcon);

export type {Props as NavIconProps};
